import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CompanyCardEmptyState = () => {
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-test": "associated-objects-card-empty-state",
    "data-test-id": "associated-objects-card-empty-state",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.emptyState.COMPANY_WITH_PLURAL.fromRecord"
    })
  });
};
export default CompanyCardEmptyState;